export default class {
  public constructor(readonly strategy: GridRequiredStrategy) {}
}
export enum GridRequiredStrategy {
  All = 'All',
  OnePerColumn = 'OnePerColumn',
  OnePerRow = 'OnePerRow',
  AtLeastOnePerColumn = 'AtLeastOnePerColumn',
  AtLeastOnePerRow = 'AtLeastOnePerRow',
}
